import { loadScript } from '../../utils/dom';
import { stripNullAndUndefined } from '../../utils/objects';
import { argsToArray } from '../../utils/func';

let pendingData = [];
let gtag = function() {
  pendingData.push(arguments);
};

let trackingCode = null;

export function init(code) {
  trackingCode = code;
  loadScript({
    src: `https://www.googletagmanager.com/gtag/js?id=${code}`,
    onLoad: () => {
      window.dataLayer = window.dataLayer || [];
      gtag = function() {
        window.dataLayer.push(arguments);
      };
      gtag('js', new Date());
      gtag('config', code, { send_page_view: false });
      pendingData.forEach(args => {
        const arr = argsToArray(args);
        if (arr[0] === 'config') {
          arr[1] = trackingCode;
        }
        gtag(...arr);
      });
      pendingData = [];
    },
    onError: () => {
      gtag = () => {};
    },
  });
}

export function trackEvent(category, action, label, value) {
  const data = {
    event_category: category,
    event_label: label,
    value,
  };
  gtag('event', action, stripNullAndUndefined(data));
}

export function trackPageView(path) {
  const loc = window.location;

  gtag('config', trackingCode, {
    page_path: path,
    page_location: `${loc.protocol}//${loc.host}${path}`,
    // HistoryTracker watches router, but title won't be accurate until route renders
    page_title: '',
  });
}



// WEBPACK FOOTER //
// ./src/app/api/analytics/google.js